import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "StudyResc",
    isNumber: true,
    isSum: true,
  },
];

export const SexToCheckItemAnalysis = {
  label: "性別",
  key: "SexToCheckItemAnalysis",
  path: "ElderlyHealthCheckup/SexToCheckItemAnalysis",
  api: "TCS_V_OldStudyList01V",
  render: (options) => (
    <Diagram.ElderlyHealthCheckup.SexToCheckItemAnalysis {...options} />
  ),
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "Gender",
      field: "Gender",
      header: "",
    },
  ],
  levelColumns,
  columns: [],
};
